import React, { Component } from 'react';
import {
  InfoCercaListWrapper,
  InfoCercaElementWrapper,
  InfoCercaElementTitle,
  InfoCercaElementPlaceHolder,
  InfoCercaSeparetor,
  InfoCercaText,
  InfoCercaLocationWrapper
} from '../CompartirElement';
import { getTranslatedKey } from './../../../Utils/TranslateUtils';
import { displayComponents } from '../../../Utils/VisorsUtils';

export default class InfoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <InfoCercaListWrapper>
        {displayComponents.cercaLayers && (
          <>
            <InfoCercaElementWrapper>
              <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('title1')}</InfoCercaElementTitle>
              <InfoCercaElementPlaceHolder fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('modalEx1')}</InfoCercaElementPlaceHolder>
            </InfoCercaElementWrapper>
            <InfoCercaSeparetor />
          </>
        )}
        {displayComponents.cercaFeatures && (
          <>
            <InfoCercaElementWrapper>
              <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('dadesCataleg')}</InfoCercaElementTitle>
              <InfoCercaElementPlaceHolder fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('modalEx2')}</InfoCercaElementPlaceHolder>
            </InfoCercaElementWrapper>
            <InfoCercaText fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('popUpSolR')}</InfoCercaText>
            <InfoCercaSeparetor />
          </>
        )}
        {displayComponents.cercaPlaces && (
          <>
            <InfoCercaElementWrapper>
              <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('selectElementsText')}</InfoCercaElementTitle>
            </InfoCercaElementWrapper>
            <InfoCercaLocationWrapper>
              <InfoCercaElementWrapper>
                <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('toponim')}</InfoCercaElementTitle>
                <InfoCercaElementPlaceHolder fontSizeEnabled={this.props.fontSizeEnabled}>
                  {getTranslatedKey('cercaPHToponim')}
                </InfoCercaElementPlaceHolder>
              </InfoCercaElementWrapper>
              <InfoCercaElementWrapper>
                <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('adreça')}</InfoCercaElementTitle>
                <InfoCercaElementPlaceHolder fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('modalEx3')}</InfoCercaElementPlaceHolder>
              </InfoCercaElementWrapper>
              <InfoCercaElementWrapper>
                <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('puntKM')}</InfoCercaElementTitle>
                <InfoCercaElementPlaceHolder fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('modalEx4')}</InfoCercaElementPlaceHolder>
              </InfoCercaElementWrapper>
              <InfoCercaElementWrapper>
                <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('coordsUTM')}</InfoCercaElementTitle>
                <InfoCercaElementPlaceHolder fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('modalEx5')}</InfoCercaElementPlaceHolder>
              </InfoCercaElementWrapper>
              <InfoCercaElementWrapper>
                <InfoCercaElementTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('coordsLatLon')}</InfoCercaElementTitle>
                <InfoCercaElementPlaceHolder fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('modalEx6')}</InfoCercaElementPlaceHolder>
              </InfoCercaElementWrapper>
            </InfoCercaLocationWrapper>
          </>
        )}
      </InfoCercaListWrapper>
    );
  }
}
